"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Option_1 = require("fp-ts/lib/Option");
var get_1 = __importDefault(require("lodash/get"));
var isBaseRecord = function (obj) {
    return Object.prototype.hasOwnProperty.call(obj, 'id') && Object.prototype.hasOwnProperty.call(obj, 'entityType');
};
var isWildcardReference = function (obj) {
    return obj instanceof Object &&
        Object.keys(obj).length === 2 &&
        Object.prototype.hasOwnProperty.call(obj, 'id') &&
        Object.prototype.hasOwnProperty.call(obj, 'schema');
};
var allPotentialIds = function (v) {
    return v.findIndex(function (e) { return typeof e !== 'string' && typeof e !== 'number'; }) === -1;
};
var adjustFieldNameToConfiguredName = function (fieldName, baseRecord, viewConfig) {
    var entity = viewConfig.entities[baseRecord.entityType];
    if (fieldName.endsWith('Id') && entity.fields[fieldName.slice(0, -2)]) {
        return fieldName.slice(0, -2);
    }
    if (fieldName.endsWith('Ids') && entity.fields[fieldName.slice(0, -3)]) {
        return fieldName.slice(0, -3);
    }
    if (fieldName.endsWith('Code') && entity.fields[fieldName.slice(0, -4)]) {
        return fieldName.slice(0, -4);
    }
    return fieldName;
};
var isAllSomeArray = function (arr) {
    return !arr.some(function (option) { return option.isNone(); });
};
var traverseGetData = function (viewConfig, path, baseRecord, entities, errorOnNonConfiguredFields) {
    if (errorOnNonConfiguredFields === void 0) { errorOnNonConfiguredFields = true; }
    var getProperty = function (k) {
        return function (immediate, _baseRecord) {
            if (!viewConfig.entities[_baseRecord.entityType]) {
                throw new Error("for field \"".concat(immediate, "\",\n                entity ").concat(_baseRecord.entityType, " not found (").concat(JSON.stringify(_baseRecord), ").\n                path: \"").concat(path, "\", base: \"").concat(JSON.stringify(baseRecord), "\""));
            }
            var adjustedFieldName = adjustFieldNameToConfiguredName(immediate, _baseRecord, viewConfig);
            if (errorOnNonConfiguredFields) {
                if (!viewConfig.entities[_baseRecord.entityType].fields[adjustedFieldName]) {
                    throw new Error("field \"".concat(adjustedFieldName, "\" in expression \"").concat(path, "\"\n                    not found on entity \"").concat(JSON.stringify(_baseRecord), "\"\n                    from ").concat(JSON.stringify(baseRecord), "\n                    "));
                }
                return viewConfig.entities[_baseRecord.entityType].fields[adjustedFieldName][k];
            }
            else {
                return (0, Option_1.fromNullable)(viewConfig.entities[_baseRecord.entityType])
                    .map(function (e) { return e.fields[adjustedFieldName]; })
                    .chain(Option_1.fromNullable)
                    .map(function (f) { return f[k]; })
                    .getOrElse(undefined);
            }
        };
    };
    var getRelatedEntity = getProperty('relatedEntity');
    var getDataType = getProperty('dataType');
    var isManyRef = function (immediate, _baseRecord) {
        var dataType = getDataType(immediate, _baseRecord);
        return dataType === 'REFMANYMANY' || dataType === 'VALUESETMANY' || dataType === 'REFMANY';
    };
    var _traverseGetData = function (_path, _baseRecord) {
        // tslint:disable-line no-any
        var splitPath = _path.split('.');
        var immediate = splitPath[0], restOfPath = splitPath.slice(1);
        if (immediate === '') {
            return (0, Option_1.some)(_baseRecord);
        }
        if (!_baseRecord || !Object.prototype.hasOwnProperty.call(_baseRecord, immediate)) {
            return Option_1.none;
        }
        if (restOfPath.length > 0) {
            var thisRef_1 = _baseRecord[immediate];
            if (isWildcardReference(thisRef_1)) {
                return (0, Option_1.fromNullable)(entities[thisRef_1.schema])
                    .mapNullable(function (te) { return te[thisRef_1.id]; })
                    .chain(function (newBaseRecord) { return _traverseGetData(restOfPath.join('.'), newBaseRecord); });
            }
            else if (typeof thisRef_1 === 'string' || typeof thisRef_1 === 'number') {
                var relatedEntity = getRelatedEntity(immediate, _baseRecord);
                if (!relatedEntity) {
                    throw new Error("relatedEntity not found for field ".concat(immediate, " on ").concat(_baseRecord.entityType));
                }
                var entityBag = entities[relatedEntity];
                if (entityBag) {
                    return _traverseGetData(restOfPath.join('.'), entityBag[thisRef_1]);
                }
            }
            else if (Array.isArray(thisRef_1) && allPotentialIds(thisRef_1) && isManyRef(immediate, _baseRecord)) {
                var relatedEntity = getRelatedEntity(immediate, _baseRecord);
                if (!relatedEntity) {
                    throw new Error("relatedEntity not found for many-field ".concat(immediate, " on ").concat(_baseRecord.entityType));
                }
                var entityBag_1 = entities[relatedEntity];
                if (!entityBag_1) {
                    return Option_1.none;
                }
                var mappedOptions = thisRef_1.map(function (id) {
                    var record = entityBag_1[id];
                    return _traverseGetData(restOfPath.join('.'), record);
                });
                // if a path expanded on the manies can't be found, include in the array of results as null.
                return (0, Option_1.some)(mappedOptions.map(function (option) { return option.toNullable(); }));
            }
            /*
                maybe handle unflattened many expansions here
            */
            // below 2 cases are for when the expansion hasn't been flattened into the entity bag
            // this happens for addressRevisions, where we don't want to normalize old addresses.
            if (thisRef_1 && typeof thisRef_1 === 'object' && isBaseRecord(thisRef_1)) {
                return _traverseGetData(restOfPath.join('.'), thisRef_1);
            }
            if (thisRef_1 && typeof thisRef_1 === 'object') {
                var _loop_1 = function (i, pathSoFar) {
                    var valueAtPath = (0, get_1.default)(_baseRecord, pathSoFar);
                    if (valueAtPath && (typeof valueAtPath === 'string' || typeof valueAtPath === 'number')) {
                        var maybeNextEntityBag = (0, Option_1.fromNullable)(viewConfig.entities[_baseRecord.entityType])
                            .chain(function (e) { return (0, Option_1.fromNullable)(e.fields[pathSoFar]); })
                            .chain(function (f) { return (0, Option_1.fromNullable)(f.relatedEntity); })
                            .chain(function (re) { return (0, Option_1.fromNullable)(entities[re]); });
                        if (maybeNextEntityBag.isSome()) {
                            return { value: _traverseGetData(splitPath.slice(i).join('.'), maybeNextEntityBag.value[valueAtPath]) };
                        }
                        else if (i === splitPath.length) {
                            return { value: (0, Option_1.some)(valueAtPath) };
                        }
                    }
                    else if (valueAtPath && typeof valueAtPath === 'object' && isBaseRecord(valueAtPath)) {
                        return { value: _traverseGetData(splitPath.slice(i).join('.'), valueAtPath) };
                    }
                    else if (!valueAtPath) {
                        return { value: Option_1.none };
                    }
                };
                /*
                    Contain mutation to the block below.
                    Traverse until we can get back into entityTraversals,
                    if not return the final value if one exists.
                */
                for (var i = 1, pathSoFar = immediate; i <= splitPath.length; pathSoFar = pathSoFar + '.' + splitPath[i++]) {
                    var state_1 = _loop_1(i, pathSoFar);
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
            }
            return Option_1.none;
        }
        var thisVal = _baseRecord[immediate];
        if (adjustFieldNameToConfiguredName(immediate, _baseRecord, viewConfig) === immediate) {
            // the field is not '*Id or *Ids or *Code
            if (typeof thisVal === 'string' || typeof thisVal === 'number') {
                var relatedEntity = getRelatedEntity(immediate, _baseRecord);
                if (relatedEntity) {
                    return (0, Option_1.fromNullable)(entities[relatedEntity]).mapNullable(function (e) { return e[thisVal]; });
                }
            }
            else if (isWildcardReference(thisVal)) {
                return (0, Option_1.fromNullable)(entities[thisVal.schema]).mapNullable(function (we) { return we[thisVal.id]; });
            }
            else if (Array.isArray(thisVal) && isManyRef(immediate, _baseRecord)) {
                // we have no current instance of wildcard-manys, but we may have to deal with that in the future.
                // this is not currently addressed here.
                var relatedEntity = getRelatedEntity(immediate, _baseRecord);
                if (relatedEntity) {
                    if (allPotentialIds(thisVal)) {
                        var entityBag_2 = entities[relatedEntity];
                        if (!entityBag_2) {
                            return Option_1.none;
                        }
                        var mappedToEntities = thisVal.map(function (id) {
                            return entityBag_2[id];
                        });
                        if (mappedToEntities.some(function (e) { return !e; })) {
                            return Option_1.none;
                        }
                        return (0, Option_1.some)(mappedToEntities);
                    }
                }
            }
        }
        return typeof thisVal === 'undefined' ? Option_1.none : (0, Option_1.some)(thisVal);
    };
    if (baseRecord && !baseRecord.entityType) {
        console.error("record needs an entityType ".concat(JSON.stringify(baseRecord))); // tslint:disable-line
    }
    return baseRecord && baseRecord.entityType
        ? _traverseGetData(path, (entities[baseRecord.entityType] || {})[baseRecord.id])
        : Option_1.none;
};
exports.default = traverseGetData;
//# sourceMappingURL=index.js.map